import {
  GETTRANSACTIONTYPELIST_SUCCESS,
  GETTRANSACTIONTYPELIST_FAILED,
  RESET_GETTRANSACTIONTYPELIST,
  LOADING_GETTRANSACTIONTYPELIST,
  NETWORK_ERROR_GETTRANSACTIONTYPELIST,
} from "../types/index";

const initialState = {
  isLoading: false,
  success: false,
  network: false,
  failed: false,
  data: {},
  message: "",
  networkError: "",
};

export default (state = initialState, action) => {
  switch (action.type) {
    case LOADING_GETTRANSACTIONTYPELIST:
      return {
        ...state,
        isLoading: true,
        success: false,
        failed: false,
        network: false,
        data: {},
        message: "",
        networkError: "",
      };
    case GETTRANSACTIONTYPELIST_FAILED:
      return {
        ...state,
        isLoading: false,
        success: false,
        failed: true,
        network: false,
        data: action.payload,
        message: "",
        networkError: "",
      };
    case GETTRANSACTIONTYPELIST_SUCCESS:
      return {
        ...state,
        isLoading: false,
        success: true,
        failed: false,
        network: false,
        data: action.payload,
        message: "",
        networkError: "",
      };
    case NETWORK_ERROR_GETTRANSACTIONTYPELIST:
      return {
        ...state,
        isLoading: false,
        success: false,
        failed: false,
        network: true,
        data: {},
        message: "",
        networkError: "",
      };
    case RESET_GETTRANSACTIONTYPELIST:
      return (state = initialState);
    default:
      return state;
  }
};
